import type { Package } from '@/api';

export const usePackagePolicy = (model: Ref<Package | undefined>) => {
    const { company, permissions, isSuperAdmin, isStaff, authority } = useCompany();
    const getPolicy = (model: Package | undefined) => {
        const update = model?.company_id === company.value?.id && permissions.value.editPrograms;

        return {
            update,
        };
    };

    const policy = computed(() => getPolicy(model.value));

    return { policy, getPolicy };
};
